import { FC } from 'react';
import { QueryClient, setLogger, QueryClientProvider } from 'react-query';
import useGeneralError from 'src/hooks/useGeneralError';

setLogger({
  log: () => {},
  warn: () => {},
  error: () => {},
});

export const queryClient = new QueryClient();

export const ReactQueryClientProvider: FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  const showGeneralError = useGeneralError();

  queryClient.setDefaultOptions({
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      onError: (err) => showGeneralError(err),
    },
    mutations: {
      onError: (err) => showGeneralError(err),
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
